export const getWaitStimated = (peopleAhead, avgElapsed) => {
	if (isNaN(peopleAhead) || isNaN(avgElapsed)) {
		return "-";
	}
	const people = peopleAhead <= 0 ? 1 : peopleAhead;
	const avg = avgElapsed <= 0 ? 180 : avgElapsed;
	const operations = people * avg;
	const minutes = operations / 60;
	const result = Math.ceil(minutes);
	return result > 180 ? 180 : result;
};
